import React from 'react';
import { cn } from '../../lib/cn';

/**
 * Generic skeleton placeholder component.
 * Accepts width/height via className or inline style.
 */
export default function Skeleton({ className = '', style }) {
  return (
    <div
      role="presentation"
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-md bg-gray-200/80 dark:bg-gray-700/70',
        'relative overflow-hidden',
        className
      )}
      style={style}
    >
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 dark:via-gray-500/40 to-transparent" />
    </div>
  );
}
